import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import SB1 from "../../Assessts/Images/Home/SlidingWithbuttons/SB1.png";
import SB2 from "../../Assessts/Images/Home/SlidingWithbuttons/SB2.png";
import SB3 from "../../Assessts/Images/Home/SlidingWithbuttons/SB3.png";
import SB4 from "../../Assessts/Images/Home/SlidingWithbuttons/SB4.png";
import SB5 from "../../Assessts/Images/Home/SlidingWithbuttons/SB5.png";
import { FaRegPaperPlane } from "react-icons/fa";
import { BiParagraph } from "react-icons/bi";
import { PiGreaterThan,PiLessThan } from "react-icons/pi";
const SlidingWithButtons = () => {

    const [Index, SetIndex] = useState(1);
    const Data = [
        {
            Image: SB1,
            text: <div className=""  >
                <span className="Web-SubHeading">Apurva</span>
                <p className="">I take this opportunity to put forward my views on the CCT test conducted by NSF (North South Foundation). This CCT test has enhanced my creativity, critical thinking, and reasoning skills. In fact, it has reinforced my classroom learning. I am very thankful to NSF for providing us with such an excellent opportunity. I have been attempting this test for the past two years, and I have found it to be really amazing and very useful, especially for science. </p>
            </div>,
        },
        {
            Image: SB2,
            text: <div className=""  >
                <span className="Web-SubHeading">Rohit</span>
                <p className="">Rural talented children like us, with the introduction of competency-based teaching and learning, feel that the CCT test conducted by North South Foundation has become more relevant and important. These tests conducted by North South Foundation indirectly prepared me to perform well in the upcoming CBSE board exams. </p>
            </div>
        },
        {
            Image: SB3,
            text: <div className=""  >
                <span className="Web-SubHeading">MR. Pradeep Kumar</span>
                <p className="" >It is a pleasure to speak about the North South Foundation CCT test. As a teacher myself, I am really thankful to North South Foundation for the philanthropic work they are doing. I feel privileged that we have a link with such a prestigious institution. I hope that in the days to come, such endeavours will continue to be taken by North South Foundation, which will benefit the rural talented children of our country.
                </p>
            </div>
        },
         {
            Image: SB4,
            text: <div className="dflex flexd-column">
                <span className="Web-SubHeading" >Ms. Mohammed Suhana Tarannum</span>
                <span className="Web-SubHeading">Lateral Entry B.Tech, Year 2023-2026</span>
                <p className="" >The NSF scholarship has been a big help, covering tuition, hostel fees, and enabling me to buy a laptop, which greatly supported my computer science studies and skill development.</p>
            </div>
        },
         {
            Image: SB5,
            text: <div className="dflex flexd-column"  >
                <span className="Web-SubHeading" >Ms. Beela Anusha</span>
                <span className="Web-SubHeading">MBBS Student, Year 2018-2023</span>
                <p className="" >It is a pleasure to speak about the North South Foundation CCT test. As a teacher myself, I am really thankful to North South Foundation for the philanthropic work they are doing. I feel privileged that we have a link with such a prestigious institution. I hope that in the days to come, such endeavours will continue to be taken by North South Foundation, which will benefit the rural talented children of our country.
                </p>
            </div>
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            SetIndex((prev) => (prev + 1) % Data.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="mt-2 dflex alignitems" style={{ position: "relative" }}>
            <div className="SButtons LButton" onClick={()=>{SetIndex((prev) =>  prev === 0 ?  Data.length - 1:  prev - 1)}}><PiLessThan/></div>
            <div className="container-fluid" >
                <Row className="IStories">
                    <Col> <div className="dflex  JCCenter"><img src={Data[Index].Image} alt="Image" className="w-75 h-75" /></div></Col>
                    <Col><div className="ISCOntent">
                        <div className=" Web-MainHeading mb-2">Impact Stories</div>
                        {Data[Index].text}
                    </div></Col>
                </Row>
            </div>
            <div className="SButtons RButton" onClick={()=>{SetIndex((prev) => (prev + 1) % Data.length);}}><PiGreaterThan/></div>
            <div className="dflex gap-3 JCCenter All_Dots">
                {Data.map((_, i) => (
                    <button key={i} onClick={() => SetIndex(i)}
                        className={`DOts ${i === Index ? "Dots-Active" : ""}`} />
                ))}
            </div>
        </div>
    )
}
export default SlidingWithButtons;